import { styled } from '../../../lib/stitches'

const Text = styled('div', {
  fontFamily: '$dm',
  userSelect: 'none',
  variants: {
    size: {
      10: { fontSize: '$10', lineHeight: '$16', fontWeight: '$regular' },
      12: { fontSize: '$12', lineHeight: '$18', fontWeight: '$regular' },
      14: { fontSize: '$14', lineHeight: '$20', fontWeight: '$regular' },
      16: { fontSize: '$16', lineHeight: '$24', fontWeight: '$medium' },
      18: { fontSize: '$18', lineHeight: '$24', fontWeight: '$medium' },
      20: { fontSize: '$20', lineHeight: '$24', fontWeight: '$semibold' },
      24: { fontSize: '$24', lineHeight: '$32', fontWeight: '$bold' },
      32: { fontSize: '$32', lineHeight: '$40', fontWeight: '$bold' },
      40: { fontSize: '$40', lineHeight: '$50', fontWeight: '$bold' }
    },
    fontWeight: {
      regular: { fontWeight: '$regular' },
      medium: { fontWeight: '$medium' },
      semibold: { fontWeight: '$semibold' },
      bold: { fontWeight: '$bold' }
    },
    type: {
      primary: { color: '$text__primary' },
      secondary: { color: '$text__secondary' },
      tertiary: { color: '$text__tertiary' },
      primary_inverted: { color: '$text_inverted__primary' },
      secondary_inverted: { color: '$text_inverted__secondary' },
      tertiary_inverted: { color: '$text_inverted__tertiary' }
    },
    overflowEllipsis: {
      true: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  },
  defaultVariants: {
    size: '12',
    type: 'primary'
  }
})

export default Text
